module.exports = __webpack_public_path__ + "static/media/claw-marks.fe44d586.svg";